import { usePunditUserContext } from "@/react/contexts";

export const useFlagEnabled = (flagName: string): boolean => {
  const { experimentation } = usePunditUserContext();

  const flags = experimentation?.flags ?? {};

  return Object.prototype.hasOwnProperty.call(flags, flagName);
};

export const useFlagValue = (flagName: string): unknown => {
  const { experimentation } = usePunditUserContext();

  const flags = experimentation?.flags ?? {};

  return flags[flagName];
};
